import { Component, Input, OnInit } from '@angular/core';
import { LabelConstants } from '../../../shared/constants/label-constants';
import { MessageConstants } from '../../../shared/constants/message-constants';
import { DocumentVersionLink } from '../../models/documentVersionLink';
import { DocumentService } from '../../services/document.service';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {
  @Input() emailUrl!:string;
  @Input() type!:string;
  @Input() version!:string;
  @Input() documentNumber!:string;
  documentVersionLink!:DocumentVersionLink;
  documentVersionTitle!:any;
  constructor(private documentService : DocumentService) { }

  ngOnInit(): void {
  }

  getTitle(emailUrl:string,version:string,type: string,documentNumber:string){
    if(type===LabelConstants.EffectiveVersionLink){
      this.documentVersionLink={
        isEffectiveVersion:true,
        isLatestVersion:false
      }
    }
    if(type==LabelConstants.LatestVersionLink){
      this.documentVersionLink={
        isEffectiveVersion:false,
        isLatestVersion:true
      }      
    }
    if (type==LabelConstants.SpecificVersionLink){
      this.documentVersionLink={
        isEffectiveVersion:false,
        isLatestVersion:false
      }     
    }
    this.documentService.getTitleOfDocumentVersion(this.documentVersionLink, this.documentNumber,this.version).subscribe((serviceData=>{
      this.documentVersionTitle=serviceData.title;
      this.sendMail(emailUrl,version,type,documentNumber);  
    }));
  } 

  sendMail(emailUrl:string,version:string,type: string,documentNumber:string){
    var tootip = this.getToolTipAccordingToType(type);
    var subject = type+' Document Version URL - '+documentNumber+ ' '+this.documentVersionTitle;
    var body = emailUrl+' - '+tootip;
    this.sendMailWithSubjectAndBody(subject,body);
  }

  getToolTipAccordingToType(type:string){
    let tooltip='';
    switch(type){
      case 'Effective':
        tooltip=MessageConstants.EffectiveVersionLinkToolTip;
        break;
      case 'Specific':
        tooltip= MessageConstants.SpecificVersionLinkToolTip;
        break;
      case 'Latest':
        tooltip= MessageConstants.LatestVersionLinkToolTip;
        break;
    }
    return tooltip;
  }

  sendMailWithSubjectAndBody(subject : string, body:string){
    window.location.href = 'mailto:' +'?'+'Subject='+subject +'&body='+body;  
  }
}
